import { useState } from "react";
import Online from "./Online/Online";
import WholesalerTabs from "../../../../../../../components/WholesalerComponents/WholesalerTabs/WholesalerTabs";

const Invitation = () => {
  const tabs = ["Online", "Closed"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <>
      <WholesalerTabs
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      {activeTab === "Online" && <Online />}
    </>
  );
};

export default Invitation;